// extracted by mini-css-extract-plugin
export var chatHtmlText = "_rn-2";
export var chatLink = "_rn-0";
export var chatText = "_rn-1";